import React, { Component } from "react";

export default class Feedback extends Component {
  render() {
    const { onCloseSection } = this.props;
    return (
      <div>
        {/* Header */}
        <div className="head-general with-back visible-xs">
          <a
            href="javascript: void(0)"
            onClick={() => onCloseSection("feedback")}
            className="back"
          >
            <img src="/png/chevron-left.png" />
          </a>
          <h4>Feedback</h4>
          <a href="javascript: void(0)" className="close" />
        </div>
        {/* Header */}
        <div className="container">
          <div className="static feedback">
            <ul className="list">
              <li className="white-bg padding-box mt-10px">
                <a href="/help">
                  Help our team with app <span className="bold">feedback</span>
                </a>
              </li>
              <li className="white-bg padding-box mt-10px">
                <a href="https://www.facebook.com/mylocaleuk">
                  <span className="bold">Like</span> us on Facebook
                </a>
              </li>
              <li className="white-bg padding-box mt-10px">
                <a href="https://twitter.com/mylocaleuk">
                  <span className="bold">Follow</span> us on Twitter
                </a>
              </li>
              <li className="white-bg padding-box mt-10px">
                <a href="https://instagram.com/mylocaleuk">
                  <span className="bold">Follow</span> us on Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}
